import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly JWT_KEY = 'jwt_token';

  constructor() {}

  /**
   * Store JWT token in session storage
   */
  setToken(token: string): void {
    sessionStorage.setItem(this.JWT_KEY, token);
  }

  /**
   * Retrieve JWT token from session storage
   */
  getToken(): string | null {
    return sessionStorage.getItem(this.JWT_KEY);
  }

  /**
   * Remove JWT token from session storage
   */
  clearToken(): void {
    sessionStorage.removeItem(this.JWT_KEY);
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return this.getToken() !== null;
  }
}
